// src/pages/AFSAAllCampaigns.jsx
import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../../utils/axios";
import CampaignCard from "../Campaign/CampaignCard";
import CampaignSearchBar from "../Campaign/CampaignSearchBar";
import OurCampaignsSkeleton from "../Campaign/OurCampaignsSkeleton";

const AFSAAllCampaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showSignificant, setShowSignificant] = useState(false);

  // ✅ fetch campaigns
  const getCampaignData = async () => {
    try {
      const response = await axiosInstance.get("/campaigns/all-campaigns");
      setCampaigns(response.data);
      setFilteredCampaigns(response.data);
      setError(false);
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCampaignData();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // ✅ search handler
  const handleSearch = (query) => {
    if (!query) {
      setFilteredCampaigns(campaigns);
    } else {
      setFilteredCampaigns(
        campaigns.filter((c) =>
          c.name.toLowerCase().includes(query.toLowerCase()),
        ),
      );
    }
  };
  const significantFiltered = filteredCampaigns.filter((c) => c.isSignificant);
  const normalFiltered = filteredCampaigns.filter((c) => !c.isSignificant);
  return (
    <div className="w-full min-h-screen bg-gray-50">
      {/* Searchbar */}
      <CampaignSearchBar title="Campaigns" onSearchClick={handleSearch} />

      {/* Campaigns Section */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-16 py-6">
        {loading ? (
          <OurCampaignsSkeleton />
        ) : error ? (
          <div className="text-center text-red-500 font-semibold text-lg py-12">
            Failed to load campaigns. Please try again later.
          </div>
        ) : filteredCampaigns.length === 0 ? (
          <div className="text-center text-gray-600 font-semibold text-lg py-12">
            No campaigns found at the moment.
          </div>
        ) : (
          <>
            {significantFiltered.length > 0 && (
              <>
                <h2 className="text-2xl font-bold mb-4">Special Campaigns</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-10">
                  {significantFiltered.map((campaign) => (
                    <CampaignCard key={campaign._id} campaign={campaign} />
                  ))}
                </div>
              </>
            )}

            <h2 className="text-2xl font-bold mb-4">Featured Campaigns</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {normalFiltered.map((campaign) => (
                <CampaignCard key={campaign._id} campaign={campaign} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AFSAAllCampaigns;
